import { gql } from '@apollo/client';
import { CreatorFields } from '../fragments';

export const AnalysisVisitFieldsFragment = gql`
  fragment AnalysisVisitFields on AnalysisVisit {
    createdAt
    creator {
      ...CreatorFields
    }
    description
    display
    id
    queryType
    status
    visitedAt
  }
  ${CreatorFields}
`;
